<template>
  <div>
    <b-col lg="9" xl="*"  v-if="$route.name === 'testmethods'" style="padding-left: 0px;">
      <h1>{{ $t('privatePage.testmethods_header') }}</h1>

      <EasyDataTable
        :headers="testMethodFields"
        :items="testMethods"
        :alternating="true"
        :rows-per-page="10000"
        :hide-rows-per-page="true"
      >
        <template #item-isExcelExportEnabled="item">
          <span v-show="item.isExcelExportEnabled" class="fa fa-check"></span>
        </template>
        <template #item-isForTestBuilder="item">
          <span v-show="item.isForTestBuilder" class="fa fa-check"></span>
        </template>
        <template #item-isActive="item">
          <span v-show="item.isActive" class="fa fa-check"></span>
        </template>
        <template #item-buttons="item">
          <b-button @click.stop="beforeEditTestMethod(item)"
                    size="sm"
                    class="fa fa-edit">
          </b-button>
        </template>
      </EasyDataTable>

        <b-button to="testmethods/testmethod" @click.stop="beforeAddTestMethod" class="btn-secondary mt-2">
          {{ $t('privatePage.testmethod_add_header') }}
        </b-button>

    </b-col>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters(['selectedCulture', 'defaultCulture']),
    ...mapGetters('testMethodsModule', ['testMethods']),
    testMethodFields() {
      return [
        { value: 'name', text: this.$t('name'), sortable: true },
        {
          value: 'isExcelExportEnabled',
          text: this.$t('privatePage.excelExportEnabled_label'),
          sortable: true
        },
        /** {
          value: 'isLsiCoachingAvailable',
          text: this.$t('privatePage.lsiCoachingAvailable_label'),
          sortable: true
        }, */
        {
          value: 'isForTestBuilder',
          text: this.$t('privatePage.isUsedForTestBuilder_label'),
          sortable: true
        },
        {
          value: 'isActive',
          text: this.$t('privatePage.isActive'),
          sortable: true
        },
        { value: 'buttons', text: ' ', tdClass: 'rightAlignedField' }
      ]
    }
  },
  methods: {
    ...mapActions('testMethodsModule', {
      getAllTestMethods: 'getAllTestMethods',
      selectTestMethod: 'selectTestMethod',
      getTestMethod: 'getTestMethod'
    }),
    ...mapActions('instructionsModule', {
      getAllInstructions: 'getAllInstructions'
    }),
    beforeEditTestMethod: function(testMethod) {
      this.getTestMethod({
        testMethodId: testMethod.id,
        languageId: this.selectedCulture.languageId
      }).then(() => {
        this.$router.push('testmethods/testmethod')
      })
    },
    beforeAddTestMethod: function() {
      this.selectTestMethod({ isActive: true })
        .then(() => {})
        .catch(() => {})
    }
  },
  created() {
    this.getAllTestMethods()
      .then(() => {})
      .catch(() => {})

    this.getAllInstructions()
      .then(() => {})
      .catch(() => {})
  }
}
</script>
